/* Whole product card is clickable (photo, price, empty space) - not only the title.
   Works for every product card on the site without editing each block:
   it finds the biggest box around the click that holds exactly ONE product link. */
(function () {
  if (window.__nvCardClick) return;
  window.__nvCardClick = true;

  var SKIP = 'a, button, input, select, textarea, label, summary, details, option, video, iframe, ' +
    '[role="button"], [role="link"], [data-variant-id], [data-add-to-cart], [onclick], ' +
    'cart-drawer, cart-notification, header, nav, footer, product-info, product-form, ' +
    '.nv-co, .nv-cp, [data-nv-noclick], cart-items, cart-drawer-items, #main-cart-footer, .cart__footer, ' +
    '.product-form, .shopify-section[id*="main-product"], .nv-sticky-atc, .nv-notice, .nv-ptr, [class*="lightbox"], [class*="modal"], [class*="popup"]';

  var down = null;
  document.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);

  function productKey(a) {
    try { return new URL(a.href, location.origin).pathname; } catch (e) { return a.getAttribute('href'); }
  }

  function findCard(start) {
    var node = start, best = null, link = null;
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1) {
        var links = node.querySelectorAll('a[href*="/products/"]');
        var seen = {}, count = 0;
        for (var i = 0; i < links.length; i++) {
          var k = productKey(links[i]);
          if (!seen[k]) { seen[k] = links[i]; count++; }
          if (count > 1) break;
        }
        if (count > 1) break;
        if (count === 1) { best = node; link = seen[Object.keys(seen)[0]]; }
      }
      node = node.parentNode;
    }
    return best ? { card: best, link: link } : null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    var t = e.target;
    if (!t || !t.closest || t.closest(SKIP)) return;
    if (down && (Math.abs(e.clientX - down.x) > 8 || Math.abs(e.clientY - down.y) > 8)) return; // a drag / swipe
    var sel = window.getSelection && window.getSelection();
    if (sel && String(sel).length > 0) return; // user is selecting text

    var hit = findCard(t);
    if (!hit) return;
    var href = hit.link.href;
    if (!href) return;

    if (e.ctrlKey || e.metaKey || hit.link.target === '_blank') window.open(href, '_blank');
    else window.location.href = href;
  });

  // pointer cursor on desktop
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.closest(SKIP)) return;
    var hit = findCard(t);
    if (hit && hit.card.style.cursor !== 'pointer') hit.card.style.cursor = 'pointer';
  }, { passive: true });
})();
